<template>
  <div class="pageBox">
    <el-row>
      <el-col :span="8">
        <el-col>
          <el-card class="box-card" style="margin-top: 2px;">
            <div slot="header" class="clearfix">
              <img src="@/assets/device/radar/icon_heart.png"/>
              <span>心率/每分钟</span>
            </div>
            <p class="box_txt">{{heart}}</p>
          </el-card>
        </el-col>
        <el-col>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <img src="@/assets/device/radar/icon_speed.png"/>
              <span>是否移动</span>
            </div>
            <p class="box_txt">{{act == 1?'是':'否'}}</p>
          </el-card>
        </el-col>
        <el-col>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <img src="@/assets/device/radar/icon_rr.png"/>
              <span>人体存在系数</span>
            </div>
            <p class="box_txt">{{human}}</p>
          </el-card>
        </el-col>
      </el-col>  
      <el-col :span="8">
        <el-col>
          <el-card class="box-card" style="margin-top: 2px;">
            <div slot="header" class="clearfix">
              <img src="@/assets/device/radar/icon_breath.png"/>
              <span>呼吸/每分钟</span>
            </div>
            <p class="box_txt">{{breathe}}</p>
          </el-card>
        </el-col>
        <el-col>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <img src="@/assets/device/radar/icon_noise.png"/>
              <span>环境音量</span>
            </div>
            <p class="box_txt">{{sound}}</p>
          </el-card>
        </el-col>
        <el-col>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <img src="@/assets/device/radar/icon_xinhao.png"/>
              <span>信号强度</span>
            </div>
            <p class="box_txt">{{wifi}}</p>
          </el-card>
        </el-col>
      </el-col>  
      <el-col :span="8">
        <el-card class="box-card" style="margin-top: 2px;">
          <div slot="header" class="clearfix">
            <img src="@/assets/device/radar/icon_data.png"/>
            <span>实时数据</span>
          </div>
          <div style="background-color: #CCDCEB;">
            <ul class="infinite-list" style="overflow:auto">
              <li v-for="i in data2List" :key="i" class="infinite-list-item">
                <el-card class="card2">
                  {{ i }}
                </el-card>
              </li>
            </ul>
            <div class="echartsBox">
              <div class="status" id="liveData" ref="statusEcharts"></div>
            </div>
          </div>
        </el-card>
      </el-col>  
      <el-col>
        <!-- 历史数据 -->
        <div class="historyBox">
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import echarts from "echarts";
import {WebsocketServerUrl} from "@/utils/request.js";
export default {
data () {
  return {
      deviceNo:'',
      heart:'-',
      rr:'-',
      breathe:'-',
      offLineStatus:'',
      data2List:5,
      status:'',
      temp:'-',
      hischart:"",
      radarData:{},
      wifi:'-',
      act:'-',
      sound:'-',
      move:'-',
      human:'-',
      breatheStatus:'正常',
      heartStatus:'正常',
      heartList:[], //实时心率数据
      breathList:[],
      timeList:[], 
      myChart:'',
      option:'',
      historyHeartList:[], //历史心率数据
      historyBreathList:[], //历史呼吸数据
      historyTimeList:[],//
      interval:null,
      time2:null,
  }
},
mounted () {
  console.log(this.$route.query);
  this.deviceNo = this.$route.query.deviceNo;
  if(this.deviceNo == null){
    this.deviceNo = sessionStorage.getItem("deviceNo");
  }
  sessionStorage.setItem("deviceNo",this.deviceNo);
  this.getRealData();
  this.initwebsocket();
  this.drawChart();
  this.getHistoryData();
},
beforeDestroy(){
  if(this.websock!=null){
    this.websock.close();
    this.websock = null;
  }
  if(this.interval!=null){
    clearInterval(this.interval);
    this.interval = null;
  }
  if(this.time2!=null){
    clearInterval(this.time2);
    this.time2 = null;
  }
},
destroyed(){
  if(this.websock!=null){
    this.websock.close();
    this.websock = null;
  }
  if(this.interval != null){
    clearInterval(this.interval)
    this.interval = null;
  }
  if(this.time2!=null){
    clearInterval(this.time2);
    this.time2 = null;
  }
},
methods: {
  getRealData(){
    if(this.deviceNo == null){
      return;
    }
    this.$postForm(
      "dmc/radar/RealData",
      {
        deviceNo:this.deviceNo
      }).then(res =>{
        console.log(res);
        if(res.code == 200){
          let statusList = [];
          if(res.result.offLine == 1){
            this.offLineStatus = "离线"
            this.heart = "-";
            this.breathe = "-";
            this.status = "-";
            this.rr = '-';
            this.goodData = "";
            this.breatheStatus = "";
            this.heartStatus = "";
            this.sound = '-';
            this.temp = '-';
            this.wifi = '-';
            this.act = '-';
            this.move = '-';
            this.hum = '-';
            this.human = '-';
            statusList.push('设备已离线');
            this.data2List = statusList;
          }else{
            this.sound = res.result.sound || '-';
            this.tem = (res.result.tem / 10).toFixed(1) +" °C";
            this.hum = (res.result.hum / 10).toFixed(1) +" %";
            this.act = res.result.act;
            this.move = res.result.move;
            this.wifi = res.result.wifi || '-' +"dB";
            this.human = res.result.human;

            this.offLineStatus = "在线"
            if(res.result.inStatus == 0){
              this.heart = res.result.heartRate;
              this.breathe = res.result.breathRate;
              if(this.breathe != 0 && this.breathe!=null){
                this.rr = (60 / this.breathe).toFixed(2);
              }
              this.status = "离床";
            }else{
              this.heart = res.result.heartRate;
              this.breathe = res.result.breathRate;
              if(this.breathe != 0 && this.breathe!=null){
                this.rr = (60 / this.breathe).toFixed(2);
              }
              this.status = "在床";
            }
            // if(res.result.human > 40){
            //   this.status = "在床";
            // }else{
            //   this.status = "离床";
            // }
            
            statusList.push('状态:'+this.status);
            // statusList.push('温度:'+ this.tem+"");
            // statusList.push('湿度:' + this.hum + "");
            statusList.push('光照强度:'+res.result.light+" 级");
            statusList.push('时间:'+res.result.createdTime);
            this.data2List = statusList;
            if(this.heart>30 && this.breathe > 5){
              this.heartList.push(this.heart);
              this.breathList.push(this.breathe);
              this.timeList.push(res.result.createdTime);
              this.myChart.setOption(this.option); 
            }
            if(this.heart>100){
              this.heartStatus = "心率过快";
            }else if(this.heart<50){
              this.heartStatus = "心率过慢";
            }
            if(this.breathe>23){
              this.breatheStatus = "呼吸过快";
            }else if(this.breathe<12){
              this.breatheStatus = "呼吸过慢";
            }
          }
        }else{
          this.offLineStatus = "离线"
            this.heart = "-";
            this.breathe = "-";
            this.status = "-";
            this.goodData = "";
            this.breatheStatus = "";
            this.heartStatus = "";
            this.sound = '-';
            this.temp = '-';
        }
      })
  },
  getHistoryData(){
    this.$postJson(
        "dmc/radar/historyDataList",
        {
          deviceNo:this.deviceNo,
          inStatus:1,
          pageNum:1,
          pageSize:99
        }).then(res =>{
          console.log(res);
          if(res.code == 200){
            res.result.list.forEach(item => {
              if(item.heartRate > 30 && item.breathRate >5){
                this.heartList.splice(0,0,item.heartRate);
                this.breathList.splice(0,0,item.breathRate);
                this.timeList.splice(0,0,item.createdTime);
              }
            });
            this.myChart.setOption(this.option); 
          }
        })
  },
  showHistoryBreathChart(){
    this.hischart = echarts.init(document.getElementById("historyBreathData"));
    var option = {
      title: {
          text: "历史呼吸数据",
      },
      xAxis: {
        data: this.historyTimeList
      },
      yAxis: {},
      tooltip: {},
      legend: {
        data: ["呼吸"],
      },
      series: [
        {
          data: this.historyBreathList,
          type: 'line',
          stack: 'x',
          smooth: true,
          color: 'blue',
          smooth: true, //是否平滑曲线显示。折线会圆滑，不然false就会有折角
          symbolSize: 8, //标记的大小，点的大小'
          sampling: "average", //取过滤点的平均值
        }
      ]
    };
    this.hischart.setOption(option);
  },
  showHistoryChart(){
    this.hischart = echarts.init(document.getElementById("historyData"));
    var option = {
      // backgroundColor: ['#081944'], // 全图默认背景
      visualMap: [
        {
          show: false,
          type: 'continuous',
          seriesIndex: 0,
          min: 0,
          max: 100
        },
        {
          show: false,
          type: 'continuous',
          seriesIndex: 1,
          dimension: 0,
          min: 0,
          max: this.historyTimeList.length - 1
        }
      ],
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
       dataZoom: [
              {
                type: "slider",
                show: this.historyTimeList.length>100,
                xAxisIndex: [0,1],
                start: 0,
                end: 10000/this.historyTimeList.length > 100?100:10000/this.historyTimeList.length
              },
            ],
      title: [
        {
          top: '2%',
          left: 'left',
          text: '历史心率',
          textStyle:{
             color: 'black'
          }
        },
        {
          top: '50%',
          left: 'left',
          text: '历史呼吸',
          textStyle:{
             color: 'black'
          }
        }
      ],
      tooltip: {
        trigger: 'axis'
      },
      xAxis: [
        {
          axisLabel:{
            color:'black'
          },
          data: this.historyTimeList
        },
        {
          axisLabel:{
            color:'black'
          },
          data: this.historyTimeList,
          gridIndex: 1
        }
      ],
      yAxis: [
        {
          axisLabel:{
            color:'black'
          },
          min:50
        },
        {
          axisLabel:{
            color:'black'
          },
          gridIndex: 1,
          min:10
        }
      ],
      grid: [
        {
          bottom: '58%'
        },
        {
          top: '55%'
        }
      ],
      series: [
        {
          type: 'line',
          showSymbol: false,
          data: this.historyHeartList
        },
        {
          type: 'line',
          showSymbol: false,
          data: this.historyBreathList,
          xAxisIndex: 1,
          yAxisIndex: 1
        }
      ]
    };
    this.hischart.setOption(option);
  },
  drawChart() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.getElementById("liveData"));
    this.option = {
      // backgroundColor: ['#081944'], // 全图默认背景
      visualMap: [
        {
          show: false,
          type: 'continuous',
          seriesIndex: 0,
          min: 0,
          max: 100
        },
        {
          show: false,
          type: 'continuous',
          seriesIndex: 1,
          dimension: 0,
          min: 0,
          max: this.timeList.length - 1
        }
      ],
       dataZoom: [
              {
                type: "slider",
                show: this.timeList.length>100,
                xAxisIndex: [0,1],
                start: 0,
                end: 10000/this.timeList.length > 100?100:10000/this.timeList.length
              },
            ],
      title: [
        {
          top: '2%',
          left: 'right',
          text: '心率',
          textStyle:{
             color: 'black',
          }
        },
        {
          top: '52%',
          left: 'right',
          text: '呼吸',
          textStyle:{
             color: 'black',
          }
        }
      ],
      tooltip: {
        trigger: 'axis'
      },
      xAxis: [
        {
          axisLabel:{
            color:'black'
          },
          data: this.timeList
        },
        {
          axisLabel:{
            color:'black'
          },
          data: this.timeList,
          gridIndex: 1
        }
      ],
      yAxis: [
        {
          axisLabel:{
            color:'black'
          },
          min:40
        },
        {
          axisLabel:{
            color:'black'
          },
          gridIndex: 1,
          min:5
        }
      ],
      grid: [
        {
          top: '4%',
          bottom: '57%',
          left: '6%',
          right:'5%'
        },
        {
          top: '94%',
          bottom: '49%',
          left: '6%',
          right:'5%'
        }
      ],
      series: [
        {
          type: 'line',
          showSymbol: false,
          data: this.heartList
        },
        {
          type: 'line',
          showSymbol: false,
          data: this.breathList,
          xAxisIndex: 1,
          yAxisIndex: 1
        }
      ]
    };
      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(this.option);
  },
  initwebsocket(){
    var userId = sessionStorage.getItem("userId");
    this.websock = new WebSocket(WebsocketServerUrl.webSocketServer+"/radar/" + userId + this.deviceNo);
    this.websock.onmessage = this.websocketonmessage;
    this.websock.onopen = this.websocketonopen;
    this.websock.onerror = this.websocketonerror;
    this.websock.onclose = this.websocketclose;
  },
  //打开时
  websocketonopen() {
    console.log("websocket连接成功");
    var message = [{
      deviceNo: this.deviceNo,
    }];
    //web sockets只能通过连接发送纯文本数据，所以对于复杂的数据结构，在通过连接发送之前，必须进行序列化。
    this.websock.send(JSON.stringify(message));
  },
  //报错时
  websocketonerror() {
    console.log("websocket连接失败");
  },
  getHttpsData(){
    if(this.deviceNo == null){
      return;
    }
    this.$postForm(
      "dmc/radar/RealData",
      {
        deviceNo:this.deviceNo
      }).then(res =>{
        console.log(res);
        if(res.code == 200){
          if(res.result.offLine == 1){
            this.offLineStatus = "离线"
            this.heart = "-";
            this.breathe = "-";
            this.status = "-";
            this.goodData = "";
            this.breatheStatus = "";
            this.heartStatus = "";
          }else{
            this.offLineStatus = "在线"
            if(res.result.isInStatus == 0){
              this.heart = res.result.heartRate;
              this.breathe = res.result.breathRate;
              this.status = "离床";
            }else{
              this.heart = res.result.heartRate;
              this.breathe = res.result.breathRate;
              this.status = "在床";
            }
            if(this.heart >0 && this.breathe>0){
              this.heartList.push(this.heart);
              this.breathList.push(this.breathe);
              this.timeList.push(res.result.createdTime);
              this.myChart.setOption(this.option);
              if(this.heart>100){
                this.heartStatus = "心率过快";
              }else if(this.heart<50){
                this.heartStatus = "心率过慢";
              }
              if(this.breathe>23){
                this.breatheStatus = "呼吸过快";
              }else if(this.breathe<12){
                this.breatheStatus = "呼吸过慢";
              }
            }
          }
        }
      })
  },
  //关闭时
  websocketclose(ev) {
    console.log("断开连接", ev);
  },
  websocketonmessage(ev) {
    //数据接收
    //通过后台返回的字段去判断
    if (ev.data) {
      let data = JSON.parse(ev.data); //将json对象转换成对象
      var heart = data.result.heart;
      var breath = data.result.breath;
      var time = data.result.createdTime;
      
      

      this.offLineStatus = "在线"
      if(data.result.inStatus == 1){
        this.heart = data.result.heart;
        this.breathe = data.result.breath;
        this.status = "在床";
      }else{
        this.heart = data.result.heart;
        this.breathe = data.result.breath;
        this.status = "离床";
      }

      // if(data.result.human > 40){
      //   this.human = data.result.human;
      //   this.status = "在床";
      // }else{
      //   this.human = data.result.human;
      //   this.status = "离床";
      // }
            
     
      if(this.data2List.length >4){
        this.data2List[0] = '状态:'+this.status;
        this.data2List[1] = '温度:'+(Number(data.result.tem)/10)+"℃";
        this.data2List[2] = '湿度:'+(Number(data.result.hum)/10)+"%";
        this.data2List[3] = '光照:'+data.result.light+" 级";
        this.data2List[4] = '时间:'+data.result.createdTime;
      }
      if(heart >0 && breath>0){
        this.heartList.push(heart);
        this.breathList.push(breath);
        this.timeList.push(time);
        this.myChart.setOption(this.option);
        if(heart>100){
          this.heartStatus = "心率过快";
        }else if(heart<50){
          this.heartStatus = "心率过慢";
        }
        if(breath>23){
          this.breatheStatus = "呼吸过快";
        }else if(breath<12){
          this.breatheStatus = "呼吸过慢";
        }
      }
    }
  }
}
}
</script>
<style lang="scss" scoped>
::v-deep .el-card__body{
  padding: 0px;
}
.box-card{
  width: 96%;
  margin-left: 2%;
  min-height: 100px;
  margin-top: 20px;
  font-size: 20px;
  background: #1395DB;
  text-align: center;
  .box_txt{
    font-size: 45px;
    text-align: center;
    padding-top: 32px;
    line-height: 52px;
    font-weight: bold;
    padding-bottom: 32px;
    background-color: #CCDCEB;
    color: #1195DB;
  }
}
.clearfix{
  background: #1395DB;
  color: white;
  img{
    width: 28px;
    height: 28px;
    margin-top: -6px;
    vertical-align: middle;
  }
}
.card2{
  font-size: 18px;
  padding: 5px;
  margin: 6px;

  text-align: left;
  background: #CCDCEB;
  color: #171C56;
}

.echartsBox {
  width: 100%;
  height: 385px;
}
.status {
  height: 385px;
  width: 100%;
}
.pageBox {
width: 100%;
// height: 100%;
background: #fff;
.el-row {
  height: 100%;
  .historyBox{
      height: 0px;
      width: 100%;
      margin-bottom: 30px;
      overflow: hidden;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }

  .leftBox {
    height: 100%;
    .titleBox {
      height: 50px;
      .el-col {
        line-height: 50px;
        .el-button {
          background: #ebc12b;
          border-color: #ebc12b;
        }
      }
      .inof {
        font-size: 24px;
        color: #4f4e4e;
        span {
          margin: 0 5px;
        }
      }
    }
    
  }
  .rightBox {
    height: 100%;
    padding-right: 20px;
    //   overflow: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    &::-webkit-scrollbar {
      display: none;
    }
    //   日历部分
    .dayBox {
      width: 100%;
      span {
        display: block;
        width: 46px;
        height: 41px;
        background-color: #ebc12b;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 5px;
        border-radius: 5px;
        i {
          font-size: 20px;
          color: #ffffff;
        }
      }
    }
    //  实时心率
    .realData {
      width: 100%;
      border: 1px solid #e1e3e9;
      margin-top: 20px;
      margin-bottom: 10px;
      box-sizing: border-box;
      //   标题
      .realTitle {
        height: 50px;
        background-color: #fafafa;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #e1e3e9;
        .icon-- {
          color: #ee6666;
          font-size: 28px;
          margin-right: 10px;
        }
        span {
          color: #494949;
          font-size: 18px;
        }
      }
      // 健康概况
      .center {
        padding: 10px;
        background-color: #fafafa;
        border-bottom: 1px solid #e1e3e9;
        p {
          color: #3e3e3e;
          font-size: 16px;
        }
        .one {
          display: flex;
          span {
            width: 50%;
            display: flex;
            flex-wrap: nowrap;
            p {
              font-size: 14px;
              margin-right: 10px;
            }
            b {
              font-size: 14px;
            }
          }
        }
        div {
          margin: 7px 0;
          span {
            display: flex;
            flex-wrap: nowrap;
            p {
              font-size: 14px;
              margin-right: 10px;
            }
            b {
              font-size: 14px;
            }
          }
        }
      }
      // 异常状态
      .list {
        padding: 10px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        p {
          color: #3e3e3e;
          font-size: 16px;
        }
        span {
          display: flex;
          justify-content: space-between;
          flex-wrap: nowrap;
          padding: 10px;
          box-shadow: 0 0 5px #f2f2f2;
          border-radius: 10px;
          box-sizing: border-box;
          p {
            font-size: 14px;
          }
          b {
            font-size: 14px;
          }
          &:nth-child(2) {
            p,
            b {
              color: #3FB212;
            }
          }
          &:nth-child(3) {
            p,
            b {
              color: #e57825;
            }
          }
          &:nth-child(4) {
            p,
            b {
              color: #62b3ff;
            }
          }
          &:nth-child(5) {
            p,
            b {
              color: #3FB212;
            }
          }
        }
      }
    }
  }
}
}
</style>